import EpisodicActor from './episodic-actor.entity';
import CmEpisodicActor from '../cm-episodic-actors/cm-episodic-actor.entity';
import EpisodicActorPicture from '../episodic-actor-pictures/episodic-actor-picture.entity';
import EpisodicCharacter from '../episodic-characters/episodic-character.entity';
import HaEpisodicActor from '../ha-episodic-actors/ha-episodic-actor.entity';
import MuEpisodicActor from '../mu-episodic-actors/mu-episodic-actor.entity';
import Picture from '../pictures/picture.entity';
import PrEpisodicActor from '../pr-episodic-actors/pr-episodic-actor.entity';
import {
	SosCreateResponse,
	SosGetResponse,
	SosListResponse,
	SosUpdateResponse,
} from '../sos-response';
import { EpisodicBaseESDoc } from '../types';

export interface EpisodicActorESDoc extends EpisodicBaseESDoc {
	first_name: string;
	last_name: string;
}

export interface EpisodicActorListResponse extends SosListResponse {
	listed: {
		EpisodicActor: EpisodicActor[];
	};
}

export interface EpisodicActorGetResponse extends SosGetResponse {
	listed: {
		CmEpisodicActor: CmEpisodicActor[];
		EpisodicActor: EpisodicActor[];
		EpisodicActorPicture: EpisodicActorPicture[];
		HaEpisodicActor: HaEpisodicActor[];
		MuEpisodicActor: MuEpisodicActor[];
		Picture: Picture[];
		PrEpisodicActor: PrEpisodicActor[];
	};
}

export interface EpisodicActorCreateResponse extends SosCreateResponse {
	created: {
		CmEpisodicActor?: CmEpisodicActor[];
		EpisodicActor: EpisodicActor[];
		HaEpisodicActor?: HaEpisodicActor[];
		MuEpisodicActor?: MuEpisodicActor[];
		PrEpisodicActor?: PrEpisodicActor[];
	};
	updated: {
		EpisodicCharacter?: EpisodicCharacter[];
	};
}

export interface EpisodicActorExportToNewSeasonReponse
	extends SosUpdateResponse {
	updated: {
		EpisodicActor: EpisodicActor[];
	};
}

export interface EpisodicActorExportToNewSeasonCheckReponse {
	episodicActorIds: number[];
}

export interface EpisodicActorUpdateReponse extends SosUpdateResponse {
	updated: {
		EpisodicActor: EpisodicActor[];
		EpisodicCharacter: EpisodicCharacter[];
		HaEpisodicActor: HaEpisodicActor[];
		MuEpisodicActor: MuEpisodicActor[];
	};
}

export interface EpisodicActorUpdateNotesReponse extends SosUpdateResponse {
	updated: {
		CmEpisodicActor?: CmEpisodicActor[];
		HaEpisodicActor?: HaEpisodicActor[];
		MuEpisodicActor?: MuEpisodicActor[];
		PrEpisodicActor?: PrEpisodicActor[];
	};
}
